import { render } from "./CateCard.vue?vue&type=template&id=6b0b6e15&scoped=true"
import script from "./CateCard.vue?vue&type=script&lang=js"
export * from "./CateCard.vue?vue&type=script&lang=js"

import "./CateCard.vue?vue&type=style&index=0&id=6b0b6e15&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0b6e15"]])

export default __exports__